import { render, staticRenderFns } from "./updateAvatarViewer.vue?vue&type=template&id=49e29d3c"
import script from "./updateAvatarViewer.vue?vue&type=script&lang=js"
export * from "./updateAvatarViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports